'use client';

import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { useCallback } from 'react';

export default function useQueryParams<T>() {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const setQueryParams = useCallback(
    (params: Partial<T>) => {
      const urlSearchParams = new URLSearchParams(searchParams?.toString());

      Object.entries(params).forEach(([key, value]) => {
        if (value === undefined || value === null) {
          urlSearchParams.delete(key);
        } else if (typeof value === 'object') {
          urlSearchParams.set(key, JSON.stringify(value));
        } else {
          urlSearchParams.set(key, String(value));
        }
      });

      const search = urlSearchParams.toString();
      const query = search ? `?${search}` : '';
      router.replace(`${pathname}${query}`);
    },
    [router, pathname, searchParams],
  );

  return { queryParams: searchParams, setQueryParams };
}
